import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-tags" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.activity.master_file_tag && _ctx.activity.master_file_tag.name)
    ? (_openBlock(), _createBlock("a", {
        key: 0,
        href: "javascript:void(0)",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTag(_ctx.activity)))
      }, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_ctx.activity.master_file_tag.name), 1)
      ]))
    : _createCommentVNode("", true)
}